import styled from "styled-components"
import { compose, space, layout } from "styled-system"

const Spacer = styled.div`
  width: 100%;
  ${compose(space, layout)}
`
export default Spacer
